export const API_VERSION = "v1"
export const API_PREFIX = `/api/${API_VERSION}`
export const MOBILE_WIDTH_MAX = 768
export const DEFAULT_PAGE_SIZE = 10

export const DEFAULT_LOADING_MESSAGE = "constants.loadingData"
export const FREEMIUM_PLAN_CODE = "freemium"
export const EVAL_CASE_LIMIT = 1000

export const SETTINGS_ROOT = "/settings"
export const SETTINGS_ENDPOINTS = {
  // account
  accountProfile: `${SETTINGS_ROOT}/account/profile`,
  accountMetrics: `${SETTINGS_ROOT}/account/metrics`,

  // organization
  organizationGeneral: `${SETTINGS_ROOT}/organization/general`,
  organizationUsers: `${SETTINGS_ROOT}/organization/users`,
  organizationWorkspaces: `${SETTINGS_ROOT}/organization/workspaces`,
  organizationBrands: `${SETTINGS_ROOT}/organization/brands`,
  organizationMetrics: `${SETTINGS_ROOT}/organization/metrics`,
  organizationPlan: `${SETTINGS_ROOT}/organization/plan`,
}

export const BILLING_OVERVIEW_REFRESH_EVENT = "codeer:billing-overview-refresh"
